module.exports = __webpack_public_path__ + "img/LogoP.5968ac9d.svg";